import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqsComponent } from './faqs/faqs.component';
import { ButtonModule } from '../button/button.module';
import { SharedModule } from '../../shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    SharedModule,
    MatExpansionModule,
    MatIconModule
  ],
  declarations: [FaqsComponent],
  exports: [FaqsComponent],
})
export class FaqsModule { }
